<template lang="pug">
div(v-if="dados.length")
  transition(name="fade")
    v-card.sem-loc-panel(v-if="aberto", elevation="6")
      .sem-loc-header
        .sem-loc-title
          v-icon(small, color="orange darken-2") mdi-map-marker-off
          span Bases de Dados: {{ totalBasesSemLocalizacao }} | Clientes: {{ totalClientesSemLocalizacao }}
        v-btn(icon, x-small, @click="aberto = false")
          v-icon(small) mdi-close
      v-divider.my-0
      .sem-loc-search
        v-text-field(
          v-model="busca"
          dense
          hide-details
          outlined
          placeholder="Pesquisar..."
          prepend-inner-icon="mdi-magnify"
          clearable
        )
      v-divider.my-0
      .sem-loc-list
        template(v-if="dadosFiltrados.length")
          template(v-for="(item, index) in dadosFiltrados")
            .sem-loc-item(:key="index")
              .sem-loc-item-header
                .sem-loc-item-nomes
                  .sem-loc-item-razao {{ item.razaoempresa || 'Não informado' }}
                  .sem-loc-item-fantasia {{ item.fantasiaempresa || 'Não informado' }}
                v-btn.sem-loc-action-btn(
                  v-if="permitirEdicaoCoordenadas"
                  outlined
                  x-small
                  color="primary"
                  @click="abrirDialog(item)"
                )
                  v-icon.sem-loc-action-icon(small, color="primary") mdi-crosshairs-gps
              .sem-loc-item-meta
                v-chip(
                  x-small
                  label
                  dark
                  :color="corSoftwareHouse(item.softhouse)"
                ) {{ item.softhouse || 'N/A' }}
                v-chip(x-small, label, color="grey lighten-3")
                  span.sem-loc-version {{ item.versao || 'N/A' }}
              .sem-loc-item-endereco
                span {{ formatarEndereco(item) }}
              .sem-loc-item-consultor
                v-chip.sem-loc-consultor-badge(
                  x-small
                  label
                  :style="{ backgroundColor: corBadgeConsultor(item.softhouse) }"
                )
                  span.sem-loc-consultor-text {{ item.consultor || 'Não informado' }}
            v-divider.my-0(v-if="index < dadosFiltrados.length - 1", :key="'d-' + index")
        .sem-loc-empty(v-else)
          span.grey--text Nenhum resultado encontrado

  v-btn.sem-loc-badge(
    fab
    small
    color="orange darken-2"
    dark
    @click="aberto = !aberto"
  )
    v-icon mdi-map-marker-off

  MapCoordenadasDialog(
    v-model="dialogCoordenadas"
    :item="itemSelecionado"
    :loading="salvando"
    @save="salvarCoordenadas"
  )
</template>

<script>
import MapCoordenadasDialog from "./MapCoordenadasDialog.vue";
import { CORES_SISTEMA } from "./mapConfig";

export default {
  name: "MapSemLocalizacao",

  components: {
    MapCoordenadasDialog
  },

  props: {
    dados: {
      type: Array,
      default: () => []
    },
    totalBasesSemLocalizacao: {
      type: Number,
      default: 0
    },
    totalClientesSemLocalizacao: {
      type: Number,
      default: 0
    },
    salvarCoordenadasMapaHandler: {
      type: Function,
      default: null
    },
    permitirEdicaoCoordenadas: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      aberto: false,
      busca: "",
      dialogCoordenadas: false,
      itemSelecionado: null,
      salvando: false
    };
  },

  computed: {
    dadosFiltrados() {
      if (!this.busca) return this.dados;
      const termo = this.busca.toLowerCase();
      return this.dados.filter(item => {
        const campos = [
          item.razaoempresa,
          item.fantasiaempresa,
          item.nomecliente,
          item.consultor,
          item.softhouse,
          item.versao,
          item.endereco,
          item.nomecidade,
          item.uf,
          String(item.codigocliente),
          String(item.codigoempresa)
        ];
        return campos.some(c => c && c.toLowerCase().includes(termo));
      });
    }
  },

  methods: {
    abrirDialog(item) {
      if (!this.permitirEdicaoCoordenadas) return;

      if (this.isMobile()) {
        this.aberto = false;
        this.$emit("dialog-opened");
      }
      this.itemSelecionado = item;
      this.dialogCoordenadas = true;
    },

    fecharPainel() {
      this.aberto = false;
    },

    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    corSoftwareHouse(sh) {
      return CORES_SISTEMA[sh] || "#757575";
    },

    corBadgeConsultor(softhouse) {
      const nome = String(softhouse || "").toLowerCase();
      if (nome.includes("controlsoft")) return "rgba(5, 148, 103, 0.2)";
      if (nome.includes("sysafra")) return "rgba(10, 90, 219, 0.2)";
      return "rgba(0, 0, 0, 0.07)";
    },

    formatarEndereco(item) {
      const partes = [item.endereco, item.bairro, item.cep, item.nomecidade, item.uf].filter(
        Boolean
      );
      return partes.length ? partes.join(", ") : "Não informado";
    },

    async salvarCoordenadas(coordenadas) {
      if (!this.itemSelecionado || !this.salvarCoordenadasMapaHandler) return;

      this.salvando = true;
      try {
        await this.salvarCoordenadasMapaHandler({
          item: this.itemSelecionado,
          coordenadas
        });
        this.dialogCoordenadas = false;
        this.itemSelecionado = null;
      } finally {
        this.salvando = false;
      }
    }
  }
};
</script>

<style scoped>
.sem-loc-badge {
  position: absolute;
  bottom: 28px;
  right: 14px;
  z-index: 1000;
}

.sem-loc-panel {
  position: absolute;
  bottom: 82px;
  right: 14px;
  z-index: 1000;
  width: min(400px, calc(100vw - 28px));
  max-height: 400px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.45), 0 2px 8px rgba(0, 0, 0, 0.25);
}

.sem-loc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 16px;
}

.sem-loc-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
}

.sem-loc-search {
  padding: 8px 12px;
}

.sem-loc-list {
  overflow-y: auto;
  max-height: 280px;
  scrollbar-width: thin;
}

.sem-loc-item {
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sem-loc-item:hover {
  background: rgba(0, 0, 0, 0.03);
}

.sem-loc-item-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.sem-loc-item-razao {
  font-size: 13px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.4;
  letter-spacing: -0.01em;
}

.sem-loc-item-fantasia {
  font-size: 11px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
  line-height: 1.4;
  margin-top: 2px;
  text-transform: uppercase;
}

.sem-loc-item-consultor {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  margin-top: 2px;
}

.sem-loc-consultor-badge {
  max-width: 100%;
  height: auto !important;
  min-height: 20px;
}

.sem-loc-consultor-text {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.7);
  line-height: 1;
}

.sem-loc-item-meta {
  display: flex;
  align-items: center;
  gap: 6px;
}

.sem-loc-version {
  font-family: monospace;
  font-weight: 700;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.9);
}

.sem-loc-item-endereco {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.4;
}

.sem-loc-empty {
  padding: 20px 16px;
  text-align: center;
}

.sem-loc-action-btn {
  min-width: 30px !important;
  width: 30px !important;
  max-width: 30px !important;
  min-height: 30px !important;
  height: 30px !important;
  max-height: 30px !important;
  padding: 0 !important;
  margin-top: 0;
  flex-shrink: 0;
  border-radius: 4px;
}

.sem-loc-action-icon {
  font-size: 15px !important;
}

::v-deep .sem-loc-action-btn .v-btn__content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
